var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * 
 * @file Helper for the box metadata related API
 * @author Box
 */

import getProp from 'lodash/get';
import uniqueId from 'lodash/uniqueId';
import File from './File';
import { getBadItemError, getBadPermissionsError } from '../util/error';
import { getTypedFileId } from '../util/file';
import { HEADER_CONTENT_TYPE, METADATA_SCOPE_ENTERPRISE, METADATA_SCOPE_GLOBAL, METADATA_TEMPLATE_PROPERTIES, METADATA_TEMPLATE_SKILLS, FIELD_METADATA_SKILLS, CACHE_PREFIX_METADATA } from '../constants';

var Metadata = function (_File) {
    _inherits(Metadata, _File);

    function Metadata() {
        _classCallCheck(this, Metadata);

        return _possibleConstructorReturn(this, (Metadata.__proto__ || Object.getPrototypeOf(Metadata)).apply(this, arguments));
    }

    _createClass(Metadata, [{
        key: 'getMetadataCacheKey',

        /**
         * Creates a key for the metadata cache
         *
         * @param {string} id - Folder id
         * @return {string} key
         */
        value: function getMetadataCacheKey(id) {
            return '' + CACHE_PREFIX_METADATA + id;
        }

        /**
         * Creates a key for the skills cache
         *
         * @param {string} id - Folder id
         * @return {string} key
         */

    }, {
        key: 'getSkillsCacheKey',
        value: function getSkillsCacheKey(id) {
            return this.getMetadataCacheKey(id) + '_skills';
        }

        /**
         * API URL for metadata
         *
         * @param {string} id - a box file id
         * @param {string} field - metadata field
         * @return {string} base url for files
         */

    }, {
        key: 'getMetadataUrl',
        value: function getMetadataUrl(id, scope, template) {
            var baseUrl = this.getUrl(id) + '/metadata';
            if (scope && template) {
                return baseUrl + '/' + scope + '/' + template;
            }

            return baseUrl;
        }

        /**
         * API URL for metadata templates
         *
         * @param {string} scope - metadata scope or id
         * @return {string} base url for files
         */

    }, {
        key: 'getMetadataTemplateUrl',
        value: function getMetadataTemplateUrl(scope) {
            return this.getBaseApiUrl() + '/metadata_templates/' + scope;
        }

        /**
         * Utility to create editors from metadata instances
         * and metadata templates.
         *
         * @param {Object} instance - metadata instance
         * @param {Object} template - metadata tempalte
         * @param {boolean} canEdit - is instance editable
         * @return {Object} metadata editor
         */

    }, {
        key: 'createEditor',
        value: function createEditor(instance, template, canEdit) {
            var data = {};
            Object.keys(instance).forEach(function (key) {
                if (!key.startsWith('$')) {
                    data[key] = instance[key];
                }
            });
            return {
                template: template,
                instance: {
                    id: instance.$id,
                    canEdit: instance.$canEdit && canEdit,
                    data: data
                }
            };
        }

        /**
         * Gets metadata templates for enterprise
         *
         * @param {string} id - file id
         * @param {string} scope - metadata scope
         * @return {Object} array of metadata templates
         */

    }, {
        key: 'getTemplates',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id, scope) {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.t0 = getProp;
                                _context.next = 3;
                                return this.xhr.get({
                                    url: this.getMetadataTemplateUrl(scope),
                                    id: getTypedFileId(id)
                                });

                            case 3:
                                _context.t1 = _context.sent;
                                _context.t2 = [];

                                _context.t3 = function (template) {
                                    return !template.hidden;
                                };

                                return _context.abrupt('return', (0, _context.t0)(_context.t1, 'data.entries', _context.t2).filter(_context.t3));

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function getTemplates(_x, _x2) {
                return _ref.apply(this, arguments);
            }

            return getTemplates;
        }()

        /**
         * Gets metadata instances for file
         *
         * @param {string} id - file id
         * @return {Object} array of metadata instances
         */

    }, {
        key: 'getInstances',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id) {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.t0 = getProp;
                                _context2.next = 3;
                                return this.xhr.get({
                                    url: this.getMetadataUrl(id),
                                    id: getTypedFileId(id)
                                });

                            case 3:
                                _context2.t1 = _context2.sent;
                                _context2.t2 = [];
                                return _context2.abrupt('return', (0, _context2.t0)(_context2.t1, 'data.entries', _context2.t2));

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function getInstances(_x3) {
                return _ref2.apply(this, arguments);
            }

            return getInstances;
        }()

        /**
         * Gets skills for file
         *
         * @param {string} id - file id
         * @return {Object} array of metadata instances
         */

    }, {
        key: 'getSkills',
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(file, successCallback, errorCallback) {
                var forceFetch = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
                var id, cache, key, skills, cards;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                id = file.id;

                                if (id) {
                                    _context3.next = 4;
                                    break;
                                }

                                errorCallback(getBadItemError());
                                return _context3.abrupt('return');

                            case 4:
                                cache = this.getCache();
                                key = this.getSkillsCacheKey(id);

                                this.successCallback = successCallback;
                                this.errorCallback = errorCallback;

                                // Clear the cache if needed
                                if (forceFetch) {
                                    cache.unset(key);
                                }

                                // Return the Cache value if it exists

                                if (!cache.has(key)) {
                                    _context3.next = 12;
                                    break;
                                }

                                this.successHandler(cache.get(key));
                                return _context3.abrupt('return');

                            case 12:

                                // The file object may already have skills in it
                                skills = {
                                    data: getProp(file, FIELD_METADATA_SKILLS)
                                };
                                _context3.prev = 13;

                                if (skills.data) {
                                    _context3.next = 18;
                                    break;
                                }

                                _context3.next = 17;
                                return this.xhr.get({
                                    url: this.getMetadataUrl(id, METADATA_SCOPE_GLOBAL, METADATA_TEMPLATE_SKILLS),
                                    id: getTypedFileId(id)
                                });

                            case 17:
                                skills = _context3.sent;

                            case 18:

                                if (!this.isDestroyed()) {
                                    cards = skills.data.cards || [];

                                    cache.set(key, cards);
                                    this.successHandler(cards);
                                }
                                _context3.next = 24;
                                break;

                            case 21:
                                _context3.prev = 21;
                                _context3.t0 = _context3['catch'](13);

                                this.errorHandler(_context3.t0);

                            case 24:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this, [[13, 21]]);
            }));

            function getSkills(_x4, _x5, _x6) {
                return _ref3.apply(this, arguments);
            }

            return getSkills;
        }()

        /**
         * API for patching skills on a file
         *
         * @param {BoxItem} file - File object for which we are changing the description
         * @param {string} field - Metadata field to patch
         * @param {Array} operations - Array of JSON patch operations
         * @param {Function} successCallback - Success callback
         * @param {Function} errorCallback - Error callback
         * @return {Promise}
         */

    }, {
        key: 'updateSkills',
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(file, operations, successCallback, errorCallback) {
                var id, permissions, metadata, cards;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                id = file.id, permissions = file.permissions;

                                if (!(!id || !permissions)) {
                                    _context4.next = 4;
                                    break;
                                }

                                errorCallback(getBadItemError());
                                return _context4.abrupt('return');

                            case 4:
                                if (permissions.can_upload) {
                                    _context4.next = 7;
                                    break;
                                }

                                errorCallback(getBadPermissionsError());
                                return _context4.abrupt('return');

                            case 7:

                                this.successCallback = successCallback;
                                this.errorCallback = errorCallback;

                                _context4.prev = 9;
                                _context4.next = 12;
                                return this.xhr.put({
                                    url: this.getMetadataUrl(id, METADATA_SCOPE_GLOBAL, METADATA_TEMPLATE_SKILLS),
                                    headers: _defineProperty({}, HEADER_CONTENT_TYPE, 'application/json-patch+json'),
                                    id: getTypedFileId(id),
                                    data: operations
                                });

                            case 12:
                                metadata = _context4.sent;

                                if (!this.isDestroyed()) {
                                    cards = metadata.data.cards || [];

                                    this.merge(this.getCacheKey(id), FIELD_METADATA_SKILLS, metadata.data);
                                    this.getCache().set(this.getSkillsCacheKey(id), cards);
                                    this.successHandler(cards);
                                }
                                _context4.next = 19;
                                break;

                            case 16:
                                _context4.prev = 16;
                                _context4.t0 = _context4['catch'](9);

                                this.errorHandler(_context4.t0);

                            case 19:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this, [[9, 16]]);
            }));

            function updateSkills(_x8, _x9, _x10, _x11) {
                return _ref4.apply(this, arguments);
            }

            return updateSkills;
        }()

        /**
         * API for patching metadata on file
         *
         * @param {BoxItem} file - File object for which we are changing the description
         * @param {Object} template - Metadata template
         * @param {Array} operations - Array of JSON patch operations
         * @param {Function} successCallback - Success callback
         * @param {Function} errorCallback - Error callback
         * @return {Promise}
         */

    }, {
        key: 'updateMetadata',
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(file, template, operations, successCallback, errorCallback) {
                var id, permissions, canEdit, metadata, cache, key, cachedMetadata, editor;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                id = file.id, permissions = file.permissions;

                                if (!(!id || !permissions)) {
                                    _context5.next = 4;
                                    break;
                                }

                                errorCallback(getBadItemError());
                                return _context5.abrupt('return');

                            case 4:
                                canEdit = !!permissions.can_upload;

                                if (canEdit) {
                                    _context5.next = 8;
                                    break;
                                }

                                errorCallback(getBadPermissionsError());
                                return _context5.abrupt('return');

                            case 8:

                                this.successCallback = successCallback;
                                this.errorCallback = errorCallback;

                                _context5.prev = 10;
                                _context5.next = 13;
                                return this.xhr.put({
                                    url: this.getMetadataUrl(id, template.scope, template.templateKey),
                                    headers: _defineProperty({}, HEADER_CONTENT_TYPE, 'application/json-patch+json'),
                                    id: getTypedFileId(id),
                                    data: operations
                                });

                            case 13:
                                metadata = _context5.sent;

                                if (!this.isDestroyed()) {
                                    cache = this.getCache();
                                    key = this.getMetadataCacheKey(id);
                                    cachedMetadata = cache.get(key);
                                    editor = this.createEditor(metadata.data, template, canEdit);

                                    cachedMetadata.editors.splice(cachedMetadata.editors.findIndex(function (_ref6) {
                                        var instance = _ref6.instance;
                                        return instance.id === editor.instance.id;
                                    }), 1, editor);
                                    this.successHandler(editor);
                                }
                                _context5.next = 20;
                                break;

                            case 17:
                                _context5.prev = 17;
                                _context5.t0 = _context5['catch'](10);

                                this.errorHandler(_context5.t0);

                            case 20:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, this, [[10, 17]]);
            }));

            function updateMetadata(_x12, _x13, _x14, _x15, _x16) {
                return _ref5.apply(this, arguments);
            }

            return updateMetadata;
        }()

        /**
         * API for creating metadata on file
         *
         * @param {BoxItem} file - File object for which we are changing the description
         * @param {Object} template - Metadata template
         * @param {Function} successCallback - Success callback
         * @param {Function} errorCallback - Error callback
         * @return {Promise}
         */

    }, {
        key: 'createMetadata',
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(file, template, successCallback, errorCallback) {
                var id, permissions, is_externally_owned, canEdit, isProperties, metadata, cache, key, cachedMetadata, editor;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                if (!(!file || !template)) {
                                    _context6.next = 3;
                                    break;
                                }

                                errorCallback(getBadItemError());
                                return _context6.abrupt('return');

                            case 3:
                                id = file.id, permissions = file.permissions, is_externally_owned = file.is_externally_owned;

                                if (!(!id || !permissions)) {
                                    _context6.next = 7;
                                    break;
                                }

                                errorCallback(getBadItemError());
                                return _context6.abrupt('return');

                            case 7:
                                canEdit = !!permissions.can_upload;
                                isProperties = template.templateKey === METADATA_TEMPLATE_PROPERTIES && template.scope === METADATA_SCOPE_GLOBAL;

                                if (!(!canEdit || is_externally_owned && !isProperties)) {
                                    _context6.next = 12;
                                    break;
                                }

                                errorCallback(getBadPermissionsError());
                                return _context6.abrupt('return');

                            case 12:

                                this.successCallback = successCallback;
                                this.errorCallback = errorCallback;

                                _context6.prev = 14;
                                _context6.next = 17;
                                return this.xhr.post({
                                    url: this.getMetadataUrl(id, template.scope, template.templateKey),
                                    id: getTypedFileId(id),
                                    data: {}
                                });

                            case 17:
                                metadata = _context6.sent;

                                if (!this.isDestroyed()) {
                                    cache = this.getCache();
                                    key = this.getMetadataCacheKey(id);
                                    cachedMetadata = cache.get(key);
                                    editor = this.createEditor(metadata.data, template, canEdit);

                                    cachedMetadata.editors.push(editor);
                                    this.successHandler(editor);
                                }
                                _context6.next = 24;
                                break;

                            case 21:
                                _context6.prev = 21;
                                _context6.t0 = _context6['catch'](14);

                                this.errorHandler(_context6.t0);

                            case 24:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, this, [[14, 21]]);
            }));

            function createMetadata(_x17, _x18, _x19, _x20) {
                return _ref7.apply(this, arguments);
            }

            return createMetadata;
        }()

        /**
         * API for deleting metadata on file
         *
         * @param {BoxItem} file - File object for which we are changing the description
         * @param {string} scope - Metadata instance scope
         * @param {string} template - Metadata template key
         * @param {Function} successCallback - Success callback
         * @param {Function} errorCallback - Error callback
         * @return {Promise}
         */

    }, {
        key: 'deleteMetadata',
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(file, template, successCallback, errorCallback) {
                var scope, templateKey, id, permissions, cache, key, metadata;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                if (!(!file || !template)) {
                                    _context7.next = 3;
                                    break;
                                }

                                errorCallback(getBadItemError());
                                return _context7.abrupt('return');

                            case 3:
                                scope = template.scope, templateKey = template.templateKey;
                                id = file.id, permissions = file.permissions;

                                if (!(!id || !permissions)) {
                                    _context7.next = 8;
                                    break;
                                }

                                errorCallback(getBadItemError());
                                return _context7.abrupt('return');

                            case 8:
                                if (permissions.can_upload) {
                                    _context7.next = 11;
                                    break;
                                }

                                errorCallback(getBadPermissionsError());
                                return _context7.abrupt('return');

                            case 11:

                                this.successCallback = successCallback;
                                this.errorCallback = errorCallback;

                                _context7.prev = 13;
                                _context7.next = 16;
                                return this.xhr.delete({
                                    url: this.getMetadataUrl(id, scope, templateKey),
                                    id: getTypedFileId(id)
                                });

                            case 16:
                                if (!this.isDestroyed()) {
                                    cache = this.getCache();
                                    key = this.getMetadataCacheKey(id);
                                    metadata = cache.get(key);

                                    metadata.editors.splice(metadata.editors.findIndex(function (editor) {
                                        return editor.template.scope === scope && editor.template.templateKey === templateKey;
                                    }), 1);
                                    this.successHandler();
                                }
                                _context7.next = 22;
                                break;

                            case 19:
                                _context7.prev = 19;
                                _context7.t0 = _context7['catch'](13);

                                this.errorHandler(_context7.t0);

                            case 22:
                            case 'end':
                                return _context7.stop();
                        }
                    }
                }, _callee7, this, [[13, 19]]);
            }));

            function deleteMetadata(_x21, _x22, _x23, _x24) {
                return _ref8.apply(this, arguments);
            }

            return deleteMetadata;
        }()

        /**
         * API for getting metadata editors
         *
         * @param {string} id - box file id
         * @param {Function} successCallback - Success callback
         * @param {Function} errorCallback - Error callback
         * @return {Promise}
         */

    }, {
        key: 'getEditors',
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(file, successCallback, errorCallback, getMetadata) {
                var _this2 = this;

                var forceFetch = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
                var id, permissions, is_externally_owned, cache, key, editors, instances, legacyInstances, customPropertiesTemplate, templates, metadata;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                id = file.id, permissions = file.permissions, is_externally_owned = file.is_externally_owned;

                                if (!(!id || !permissions)) {
                                    _context8.next = 4;
                                    break;
                                }

                                errorCallback(getBadItemError());
                                return _context8.abrupt('return');

                            case 4:
                                cache = this.getCache();
                                key = this.getMetadataCacheKey(id);
                                editors = [];

                                this.successCallback = successCallback;
                                this.errorCallback = errorCallback;

                                // Clear the cache if needed
                                if (forceFetch) {
                                    cache.unset(key);
                                }

                                // Return the Cache value if it exists

                                if (!cache.has(key)) {
                                    _context8.next = 13;
                                    break;
                                }

                                successCallback(cache.get(key));
                                return _context8.abrupt('return');

                            case 13:
                                _context8.prev = 13;
                                _context8.next = 16;
                                return this.getInstances(id);

                            case 16:
                                instances = _context8.sent;

                                if (!getMetadata) {
                                    _context8.next = 23;
                                    break;
                                }

                                _context8.next = 20;
                                return getMetadata(id);

                            case 20:
                                _context8.t0 = _context8.sent;
                                _context8.next = 24;
                                break;

                            case 23:
                                _context8.t0 = null;

                            case 24:
                                legacyInstances = _context8.t0;
                                customPropertiesTemplate = [{
                                    id: uniqueId('metadata_template_'),
                                    scope: METADATA_SCOPE_GLOBAL,
                                    templateKey: METADATA_TEMPLATE_PROPERTIES,
                                    hidden: false
                                }];
                                _context8.t2 = customPropertiesTemplate;
                                _context8.next = 29;
                                return this.getTemplates(id, METADATA_SCOPE_ENTERPRISE);

                            case 29:
                                _context8.t3 = _context8.sent;
                                _context8.t1 = _context8.t2.concat.call(_context8.t2, _context8.t3);
                                _context8.next = 33;
                                return this.getTemplates(id, METADATA_SCOPE_GLOBAL);

                            case 33:
                                _context8.t4 = _context8.sent;
                                templates = _context8.t1.concat.call(_context8.t1, _context8.t4);

                                if (!this.isDestroyed()) {
                                    _context8.next = 37;
                                    break;
                                }

                                return _context8.abrupt('return');

                            case 37:

                                instances.forEach(function (instance) {
                                    var templateKey = instance.$template;
                                    var scope = instance.$scope;
                                    var template = templates.find(function (t) {
                                        return t.templateKey === templateKey && t.scope === scope;
                                    });

                                    if (!template && legacyInstances && legacyInstances.entries && legacyInstances.entries.length > 0) {
                                        template = _this2.createTemplateFromLegacy(legacyInstances.entries, templateKey, scope);
                                    }

                                    if (template && !template.hidden) {
                                        editors.push(_this2.createEditor(instance, template, !!permissions.can_upload));
                                    }
                                });

                                metadata = {
                                    editors: editors,
                                    templates: is_externally_owned ? customPropertiesTemplate : templates
                                };

                                cache.set(key, metadata);
                                this.successHandler(metadata);
                                _context8.next = 46;
                                break;

                            case 43:
                                _context8.prev = 43;
                                _context8.t5 = _context8['catch'](13);

                                this.errorHandler(_context8.t5);

                            case 46:
                            case 'end':
                                return _context8.stop();
                        }
                    }
                }, _callee8, this, [[13, 43]]);
            }));

            function getEditors(_x25, _x26, _x27, _x28) {
                return _ref9.apply(this, arguments);
            }

            return getEditors;
        }()
    }, {
        key: 'createTemplateFromLegacy',
        value: function createTemplateFromLegacy(legacyInstances, templateKey, scope) {
            var fields = [];
            var legacyInstance = legacyInstances.find(function (instance) {
                var template = instance.type.substring(0, instance.type.indexOf('-'));
                return template === templateKey && instance.scope === scope;
            });

            if (!legacyInstance) {
                return null;
            }

            legacyInstance.fields.forEach(function (_ref10) {
                var key = _ref10.key,
                    type = _ref10.type,
                    displayName = _ref10.displayName,
                    options = _ref10.options,
                    description = _ref10.description;

                fields.push({
                    id: uniqueId('metadata_field_'),
                    type: type,
                    key: key,
                    displayName: displayName,
                    description: description,
                    options: Array.isArray(options) ? options.map(function (option) {
                        return { key: option.value };
                    }) : undefined
                });
            });

            return {
                id: legacyInstance.type,
                scope: scope,
                templateKey: templateKey,
                displayName: legacyInstance.displayName,
                fields: fields,
                hidden: legacyInstance.hidden
            };
        }
    }]);

    return Metadata;
}(File);

export default Metadata;